export const CONTRACT_SALES_LISTING = "CONTRACT_SALES_LISTING";
